// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__26YJy","error":"Textarea_error__2KB2V","readonly":"Textarea_readonly__32Ovf","disabled":"Textarea_disabled__c_cfE"};